import { Stack, Typography } from "@mui/material";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

// Shared by WhatsAppCampaignsPage and the Plans table's WhatsApp/Email Status columns —
// single source so an outreach status looks the same wherever it's shown. "sent" is the
// default the moment Meta accepts the send; delivered/read arrive later via the webhook.
// Read's blue is WhatsApp's own recognizable tick color, kept as-is rather than a brand token.
export const MESSAGE_STATUS = {
  sent: { label: "Sent", icon: DoneRoundedIcon, color: "#6B7280" },
  delivered: { label: "Delivered", icon: DoneAllRoundedIcon, color: "#6B7280" },
  read: { label: "Read", icon: DoneAllRoundedIcon, color: "#53BDEB", bold: true },
  replied: { label: "Replied", icon: ReplyRoundedIcon, color: "#09AC31", bold: true },
  failed: { label: "Failed", icon: ErrorOutlineRoundedIcon, color: "#E34C14" },
};

const MessageStatusBadge = ({ status, fontSize = 12.5 }) => {
  const s = MESSAGE_STATUS[status] || MESSAGE_STATUS.sent;
  const Icon = s.icon;
  return (
    <Stack direction="row" spacing={0.4} alignItems="center">
      <Icon sx={{ fontSize: 15, color: s.color }} />
      <Typography sx={{ fontSize, color: s.color, fontWeight: s.bold ? 700 : 500 }}>{s.label}</Typography>
    </Stack>
  );
};

export default MessageStatusBadge;
